/**
 * Normalize facebook URLs of all patterns to https://www.facebook.com/{handle}
 */
export function normalizeFacebookURL(inputURL) {
  const facebookUserId = (inputURL && inputURL.split('.com/')[1]) || ''
  const normalizedFacebookURL = `https://www.facebook.com/${facebookUserId}`
  return normalizedFacebookURL
}
